export default {
  nav: {
    categories: 'Kategorier',
    topSites: 'Toppsajter',
    compare: 'Jämför',
    submitSite: 'Skicka in sajt',
    about: 'Om',
    logIn: 'Logga in',
  },
  common: {
    back: 'Tillbaka',
    search: 'Sök',
    loading: 'Laddar…',
    viewSimilarSites: 'Visa liknande sajter',
  },
  hero: {
    badge: 'Sajtdiscovery-motor',
    titleA: 'Hitta webbplatser som liknar',
    titleB: 'dina favoriter.',
    titlePrefix: 'Hitta webbplatser som liknar',
    titleAccent: 'dina favoriter.',
    subtitle: 'Upptäck konkurrenter, alternativ och dolda guldkorn på webben med exakta likhetsbetyg.',
    placeholder: 'Ange en domän (t.ex. stripe.com)',
    inputPlaceholder: 'Ange en domän (t.ex. stripe.com)',
    step1Label: 'Ange en domän',
    step1Desc: 'Skriv in en webbadress för att börja',
    step2Label: 'Få träffar',
    step2Desc: 'Vår motor hittar liknande sajter direkt',
    step3Label: 'Jämför och välj',
    step3Desc: 'Analysera och jämför alternativ',
    steps: {
      step1Label: 'Ange en domän',
      step1Desc: 'Skriv in en webbadress för att börja',
      step2Label: 'Få träffar',
      step2Desc: 'Vår motor hittar liknande sajter direkt',
      step3Label: 'Jämför och välj',
      step3Desc: 'Analysera och jämför alternativ',
    },
  },
  footer: {
    newsletterTitle: 'Håll dig uppdaterad',
    newsletterDesc: 'Få veckorapporter om trendande sajter och nya alternativ.',
    emailPlaceholder: 'din@email.se',
    subscribe: 'Prenumerera',
    brandDesc: 'Upptäck webbens dolda kopplingar. Hitta sajter som liknar dina favoriter med exakt poängsättning.',
    explore: 'Utforska',
    popular: 'Populärt',
    company: 'Företag',
    compareSites: 'Jämför sajter',
    sitesLike: 'Sajter som',
    contact: 'Kontakt',
    faq: 'FAQ',
    removeYourSite: 'Ta bort din sajt',
    privacyPolicy: 'Integritetspolicy',
    termsOfService: 'Användarvillkor',
    rights: 'Alla rättigheter förbehållna.',
  },
  notFound: {
    title: 'Hoppsan! Sidan hittades inte',
    returnHome: 'Tillbaka till startsidan',
  },
  submitPage: {
    ctaTitle: 'Känner du till en bra webbplats?',
    ctaDesc: 'Hjälp oss växa genom att skicka in sajter du gillar. Det tar bara några sekunder.',
    ctaButton: 'Skicka in sajt',
    pageTitle: 'Skicka in en sajt',
    pageSubtitle: 'Hjälp oss genom att skicka in en webbplats för indexering.',
    successTitle: 'Sajt inskickad!',
    successReviewPrefix: 'Vi granskar',
    successReviewSuffix: 'och lägger till den i vårt index inom kort.',
    backHome: 'Tillbaka till startsidan',
    domainLabel: 'Domän *',
    domainPlaceholder: 't.ex. example.com',
    descriptionLabel: 'Beskrivning',
    descriptionPlaceholder: 'Kort beskrivning av webbplatsen',
    categoryLabel: 'Kategori',
    categorySelect: 'Välj kategori',
    alternativeTo: 'Alternativ till (valfritt)',
    alternativeNone: 'Inget — inte ett alternativ',
    emailLabel: 'Din e-post',
    emailPlaceholder: 'du@exempel.se',
    submitButton: 'Skicka in sajt',
    submitFailed: 'Kunde inte skicka in',
    seoTitle: 'Skicka in sajt | CiteMatch',
    seoDesc: 'Skicka in en webbplats för indexering på CiteMatch.',
  },
};

